import { e as _taggedTemplateLiteral } from './_rollupPluginBabelHelpers-fb970440.js';
import { gql } from '@apollo/client';

var _templateObject;
var MOBILE_NUMBER_STARTING_WITH = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query mobileNumberStartingWith {\n    mobileNumberStartingWith {\n      code\n      value\n    }\n  }\n"])));

export { MOBILE_NUMBER_STARTING_WITH as M };
